/**
 * API Client - Centralized Axios configuration
 * - Auto-injects JWT tokens into requests
 * - Handles token expiry and logout
 * - Used by all API service files
 */

import axios from "axios";

const apiClient = axios.create({
  // baseURL: '/api',
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to all requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Flag to prevent multiple logout redirects
let logoutInProgress = false;

// Handle 401 errors (token expiry)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !logoutInProgress) {
      logoutInProgress = true;
      localStorage.removeItem('authToken');
      // Do NOT redirect immediately - let React handle authentication state
      // The lack of token will cause React to redirect appropriately
      setTimeout(() => { logoutInProgress = false; }, 5000); // Reset flag after 5 seconds
    }
    return Promise.reject(error);
  }
);

export default apiClient;
